import {Swiper} from "swiper";
$(function() {

    let isDesktopLarge = window.matchMedia("(min-width: 992px)").matches;

    //<editor-fold desc="Homeswiper Main Init">
    if ($(".homepage-swiper").length) {
        var hsSwiper = new Swiper(".homepage-swiper", {
            navigation: {
                nextEl: ".homepage-swiper__next.swiper-button-next",
                prevEl: ".homepage-swiper__prev.swiper-button-prev"
            },
            speed: 1000,

            spaceBetween: 0,
            loop: false,
            lazy: true,
            slidesPerView: 1,
            centeredSlides: false,
            pagination: {
                el: ".homepage-swiper .swiper-pagination",
                type: "bullets"
            },

            on: {
                init: function () {


                    setTimeout(function()
                    {
                        var index_currentSlide = hsSwiper.activeIndex;
                        var currentSlide = hsSwiper.slides[index_currentSlide];

                        var card = currentSlide.querySelector('.homepage-swiper__text-wrapper');
                        card && card.classList.remove("hidden");
                        card && card.classList.add("animate__animated");
                        card && card.classList.add("animate__fadeInRight");

                        setTimeout(function() {
                            var button = currentSlide.querySelector('.homepage-swiper__button');
                            button && button.classList.remove("hidden");
                            button && button.classList.add("d-flex");
                            button && button.classList.add("animate__fadeInRight");
                            button && button.classList.add("animate__animated");
                        }, 200)
                    },10)
                },

                slideChange: function () {
                    var index_currentSlide = hsSwiper.activeIndex;
                    var currentSlide = hsSwiper.slides[index_currentSlide];
                    var nextSlide = hsSwiper.slides[index_currentSlide+1];
                    var prevSlide = hsSwiper.slides[index_currentSlide-1];

                    var card = currentSlide.querySelector('.homepage-swiper__text-wrapper');
                    card && card.classList.remove("hidden");
                    card && card.classList.add("animate__fadeInRight");
                    card && card.classList.add("animate__animated");

                    setTimeout(function() {
                        var button = currentSlide.querySelector('.homepage-swiper__button');
                        button && button.classList.remove("hidden");
                        button && button.classList.add("d-flex");
                        button && button.classList.add("animate__fadeInRight");
                        button && button.classList.add("animate__animated");
                    }, 300)

                    if(typeof prevSlide !== 'undefined'){
                        var cardPrev = prevSlide.querySelector('.homepage-swiper__text-wrapper');
                        cardPrev && cardPrev.classList.add("hidden");
                        cardPrev && cardPrev.classList.remove("animate__animated");
                        cardPrev && cardPrev.classList.remove("animate__fadeInRight");

                        var buttonPrev = prevSlide.querySelector('.homepage-swiper__button');
                        buttonPrev && buttonPrev.classList.add("hidden");
                        buttonPrev && buttonPrev.classList.remove("d-flex");
                        buttonPrev && buttonPrev.classList.remove("animate__fadeInRight");
                        buttonPrev && buttonPrev.classList.remove("animate__animated");
                    }

                    if(typeof nextSlide !== 'undefined'){
                        var cardNext = nextSlide.querySelector('.homepage-swiper__text-wrapper');
                        cardNext && cardNext.classList.add("hidden");
                        cardNext && cardNext.classList.remove("animate__animated");
                        cardNext && cardNext.classList.remove("animate__fadeInRight");

                        var buttonNext = nextSlide.querySelector('.homepage-swiper__button');
                        buttonNext && buttonNext.classList.add("hidden");
                        buttonNext && buttonNext.classList.remove("d-flex");
                        buttonNext && buttonNext.classList.remove("animate__fadeInRight");
                        buttonNext && buttonNext.classList.remove("animate__animated");
                    }
                },
            }
        });



        $.each($(".homepage-swiper__pagination .swiper-pagination-bullet"), function (index, item) {
            $(item)[0].dataset.index = index;
        });

        $(".homepage-swiper__pagination").on("click", ".swiper-pagination-bullet", function () {
            var index = $(this)[0].dataset.index;

            hsSwiper.slideTo(index);
        });
    }
    //</editor-fold>

    //<editor-fold desc="Content Swiper Main Init">
    if ($(".content-swiper").length) {
        var ctSwiper = new Swiper(".content-swiper", {
            navigation: {
                nextEl: ".content-swiper__next.swiper-button-next",
                prevEl: ".content-swiper__prev.swiper-button-prev"
            },
            spaceBetween: 0,
            loop: false,
            lazy: true,
            slidesPerView: 1,
            centeredSlides: false,
            pagination: {
                el: ".content-swiper .swiper-pagination",
                type: "bullets"
            },
            on: {
                init: function () {
                    $(".content-swiper__content--bg").css("backgroundImage", $(".content-swiper__item.swiper-slide-active").find(".content-swiper__img").css("backgroundImage"));
                }
            }
        });

        $.each($(".content-swiper__pagination .swiper-pagination-bullet"), function (index, item) {
            $(item)[0].dataset.index = index;
        });

        if ($(".content-swiper__pagination .swiper-pagination-bullet").length == 1) {
            $(".content-swiper__pagination, .content-swiper__prev, .content-swiper__next").hide();
        }

        $(".content-swiper__pagination").on("click", ".swiper-pagination-bullet", function () {
            var index = $(this)[0].dataset.index;

            ctSwiper.slideTo(index);
        });

        ctSwiper.on("slideChangeTransitionEnd", function () {
            $(".content-swiper__content--bg").css("backgroundImage", $(".content-swiper__item.swiper-slide-active").find(".content-swiper__img").css("backgroundImage"));
        });
    }
    //</editor-fold>

    //<editor-fold desc="Kategorie Swiper Init">
    if ($(".category-swiper").length) {
        new Swiper(".category-swiper", {
            spaceBetween: 0,
            loop: false,
            slidesPerView: 1,
            centeredSlides: false
        });
    }
    //</editor-fold>

    //<editor-fold desc="1. Swiper im Homepage Crossselling Widget, initial angezeigt">
    if ($(".sale-swiper").length) {
        var swiper1 = new Swiper(".sale-swiper", {
            navigation: {
                nextEl: ".sale-swiper-controls .swiper-button-next",
                prevEl: ".sale-swiper-controls .swiper-button-prev"
            },
            spaceBetween: 0,
            loop: false,
            slidesPerView: 1,
            centeredSlides: false,
            pagination: {
                el: ".sale-swiper-pagination",
                type: "fraction"
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 0
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 0
                }
            },
            on: {
                init: function () {
                    $("#tab1-control").click();
                }
            }
        });

        $("#tab1-control").click();

        swiper1.on("slideChange", function () {
            if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                var evt = document.createEvent("UIEvents");
                evt.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(evt);
            } else {
                window.dispatchEvent(new Event("resize"));

            }
        });

        if (isDesktopLarge) {
            var tsInterval = setInterval(function () {

                if ($(".homepage__crossselling .tab-pane.active .swiper-controls").length) {
                    $(".homepage__crossselling--desktop-pagination").html("");
                    $(".homepage__crossselling .tab-pane.active .swiper-controls").appendTo(".homepage__crossselling--desktop-pagination");
                    $(".homepage__crossselling--desktop-pagination .swiper-controls").removeClass("d-none");
                    clearInterval(tsInterval);
                }

                if ($(".single__crossselling .tab-pane.active .swiper-controls").length) {
                    $(".single__crossselling--desktop-pagination").html("");
                    $(".single__crossselling .tab-pane.active .swiper-controls").appendTo(".single__crossselling--desktop-pagination");
                    clearInterval(tsInterval);
                }

            }, 250);
        }
    }
    //</editor-fold>

    //<editor-fold desc="2. Swiper im Homepage Crossselling Widget, initial hidden">
    if ($(".top-swiper").length) {
        var swiper2 = new Swiper(".top-swiper", {
            navigation: {
                nextEl: ".top-swiper-controls .swiper-button-next",
                prevEl: ".top-swiper-controls .swiper-button-prev"
            },
            spaceBetween: 5,
            loop: false,
            slidesPerView: 1,
            centeredSlides: false,
            pagination: {
                el: ".top-swiper-pagination",
                type: "fraction"
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 0
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 5
                }
            }
        });
    }
    //</editor-fold>

    //<editor-fold desc="3. Swiper im Homepage Crossselling Widget, initial hidden">
    if ($(".accessoires-swiper").length) {
        var swiper3 = new Swiper(".accessoires-swiper", {
            navigation: {
                nextEl: ".accessoires-swiper-controls .swiper-button-next",
                prevEl: ".accessoires-swiper-controls .swiper-button-prev"
            },
            spaceBetween: 5,
            loop: false,
            slidesPerView: 4,
            centeredSlides: false,
            pagination: {
                el: ".accessoires-swiper-pagination",
                type: "fraction"
            },
            breakpoints: {
                767: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 5
                }
            }
        });
    }
    //</editor-fold>

    //<editor-fold desc="4. Swiper im Homepage Crossselling Widget (optional), initial hidden">
    if ($(".fourth-swiper").length) {
        var swiper3_1 = new Swiper(".fourth-swiper", {
            navigation: {
                nextEl: ".fourth-swiper-controls .swiper-button-next",
                prevEl: ".fourth-swiper-controls .swiper-button-prev"
            },
            spaceBetween: 5,
            loop: false,
            slidesPerView: 4,
            centeredSlides: false,
            pagination: {
                el: ".fourth-swiper-pagination",
                type: "fraction"
            },
            breakpoints: {
                767: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 5
                }
            }
        });
    }
    //</editor-fold>

    //<editor-fold desc="1. Swiper im Homepage Crossselling Widget neu initialiseren bei Tab Klick">
    $("#tab1-control").click(function () {
        swiper1.destroy();
        if ($(".sale-swiper-controls").length == 0) {
            $(".sale-swiper").append("<div class=\"swiper-controls sale-swiper-controls\">\n" +
                "                        <div class=\"swiper-button-prev\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-button-next\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-pagination sale-swiper-pagination swiper-pagination-fraction\"></div>\n" +
                "                    </div>");
        }
        $(".sale-swiper").addClass("hidden-for-init");
        setTimeout(function () {
            swiper1 = new Swiper(".sale-swiper", {
                navigation: {
                    nextEl: ".sale-swiper-controls .swiper-button-next",
                    prevEl: ".sale-swiper-controls .swiper-button-prev"
                },
                spaceBetween: 5,
                loop: false,
                slidesPerView: 1,
                centeredSlides: false,
                pagination: {
                    el: ".sale-swiper-pagination",
                    type: "fraction"
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 0
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 5
                    }
                }
            });

            if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                var evt = document.createEvent("UIEvents");
                evt.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(evt);
            } else {
                window.dispatchEvent(new Event("resize"));

            }
            if (isDesktopLarge) {
                var tsInterval = setInterval(function () {

                    if ($(".homepage__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".homepage__crossselling--desktop-pagination").html("");
                        $(".homepage__crossselling .tab-pane.active .swiper-controls").appendTo(".homepage__crossselling--desktop-pagination");
                        clearInterval(tsInterval);
                    }

                    if ($(".single__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".single__crossselling--desktop-pagination").html("");
                        $(".single__crossselling .tab-pane.active .swiper-controls").appendTo(".single__crossselling--desktop-pagination");
                        clearInterval(tsInterval);
                    }

                }, 250);
            }

            $(".sale-swiper").removeClass("hidden-for-init");

        }, 400);
    });
    //</editor-fold>

    //<editor-fold desc="2. Swiper im Homepage Crossselling Widget neu initialiseren bei Tab Klick">
    $("#tab2-control").click(function () {
        swiper2.destroy();
        if ($(".top-swiper-controls").length == 0) {
            $(".top-swiper").append("<div class=\"swiper-controls top-swiper-controls\">\n" +
                "                        <div class=\"swiper-button-prev\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-button-next\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-pagination top-swiper-pagination\"></div>\n" +
                "                    </div>");
        }
        $(".top-swiper").addClass("hidden-for-init");
        setTimeout(function () {
            swiper2 = new Swiper(".top-swiper", {
                navigation: {
                    nextEl: ".top-swiper-controls .swiper-button-next",
                    prevEl: ".top-swiper-controls .swiper-button-prev"
                },
                spaceBetween: 5,
                loop: false,
                slidesPerView: 1,
                centeredSlides: false,
                pagination: {
                    el: ".top-swiper-pagination",
                    type: "fraction"
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 0
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 5
                    }
                }
            });
            if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                var evt = document.createEvent("UIEvents");
                evt.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(evt);
            } else {
                window.dispatchEvent(new Event("resize"));

            }
            if (isDesktopLarge) {
                var tsInterval = setInterval(function () {

                    if ($(".homepage__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".homepage__crossselling--desktop-pagination").html("");
                        $(".homepage__crossselling .tab-pane.active .swiper-controls").appendTo(".homepage__crossselling--desktop-pagination");
                        $(".homepage__crossselling--desktop-pagination .swiper-controls").removeClass("d-none");
                        clearInterval(tsInterval);
                    }

                    if ($(".single__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".single__crossselling--desktop-pagination").html("");
                        $(".single__crossselling .tab-pane.active .swiper-controls").appendTo(".single__crossselling--desktop-pagination");
                        clearInterval(tsInterval);
                    }

                }, 250);
            } else {
                $(".top-swiper-controls").removeClass("d-none");
            }

            $(".top-swiper").removeClass("hidden-for-init");

        }, 400);
    });
    //</editor-fold>

    //<editor-fold desc="3. Swiper im Homepage Crossselling Widget neu initialiseren bei Tab Klick">
    $("#tab3-control").click(function () {
        swiper3.destroy();
        if ($(".accessoires-swiper-controls").length == 0) {
            $(".accessoires-swiper").append("<div class=\"swiper-controls accessoires-swiper-controls\">\n" +
                "                        <div class=\"swiper-button-prev\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-button-next\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-pagination accessoires-swiper-pagination\"></div>\n" +
                "                    </div>");
        }
        $(".accessoires-swiper").addClass("hidden-for-init");
        setTimeout(function () {
            swiper3 = new Swiper(".accessoires-swiper", {
                navigation: {
                    nextEl: ".accessoires-swiper-controls .swiper-button-next",
                    prevEl: ".accessoires-swiper-controls .swiper-button-prev"
                },
                spaceBetween: 5,
                loop: false,
                slidesPerView: 4,
                centeredSlides: false,
                pagination: {
                    el: ".accessoires-swiper-pagination",
                    type: "fraction"
                },
                breakpoints: {
                    767: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    }
                }
            });
            if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                var evt = document.createEvent("UIEvents");
                evt.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(evt);
            } else {
                window.dispatchEvent(new Event("resize"));

            }
            if (isDesktopLarge) {
                var tsInterval = setInterval(function () {

                    if ($(".homepage__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".homepage__crossselling--desktop-pagination").html("");
                        $(".homepage__crossselling .tab-pane.active .swiper-controls").appendTo(".homepage__crossselling--desktop-pagination");
                        $(".homepage__crossselling--desktop-pagination .swiper-controls").removeClass("d-none");
                        clearInterval(tsInterval);
                    }

                    if ($(".single__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".single__crossselling--desktop-pagination").html("");
                        $(".single__crossselling .tab-pane.active .swiper-controls").appendTo(".single__crossselling--desktop-pagination");
                        clearInterval(tsInterval);
                    }

                }, 250);
            } else {
                $(".accessoires-swiper-controls").removeClass("d-none");
            }

            $(".accessoires-swiper").removeClass("hidden-for-init");

        }, 400);
    });
    //</editor-fold>

    //<editor-fold desc="4. Swiper im Homepage Crossselling Widget neu initialiseren bei Tab Klick">
    $("#tab4-control").click(function () {
        swiper3_1.destroy();
        if ($(".fourth-swiper-controls").length == 0) {
            $("fourth-swiper").append("<div class=\"swiper-controls fourth-swiper-controls\">\n" +
                "                        <div class=\"swiper-button-prev\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-button-next\"><svg class=\"homepage__crossselling--arrow\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg></div>\n" +
                "                        <div class=\"swiper-pagination fourth-swiper-pagination\"></div>\n" +
                "                    </div>");
        }
        $(".fourth-swiper").addClass("hidden-for-init");
        setTimeout(function () {
            swiper3_1 = new Swiper(".fourth-swiper", {
                navigation: {
                    nextEl: ".fourth-swiper-controls .swiper-button-next",
                    prevEl: ".fourth-swiper-controls .swiper-button-prev"
                },
                spaceBetween: 5,
                loop: false,
                slidesPerView: 4,
                centeredSlides: false,
                pagination: {
                    el: ".fourth-swiper-pagination",
                    type: "fraction"
                },
                breakpoints: {
                    767: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    }
                }
            });
            if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                var evt = document.createEvent("UIEvents");
                evt.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(evt);
            } else {
                window.dispatchEvent(new Event("resize"));

            }
            if (isDesktopLarge) {
                var tsInterval = setInterval(function () {

                    if ($(".homepage__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".homepage__crossselling--desktop-pagination").html("");
                        $(".homepage__crossselling .tab-pane.active .swiper-controls").appendTo(".homepage__crossselling--desktop-pagination");
                        $(".homepage__crossselling--desktop-pagination .swiper-controls").removeClass("d-none");
                        clearInterval(tsInterval);
                    }

                    if ($(".single__crossselling .tab-pane.active .swiper-controls").length) {
                        $(".single__crossselling--desktop-pagination").html("");
                        $(".single__crossselling .tab-pane.active .swiper-controls").appendTo(".single__crossselling--desktop-pagination");
                        clearInterval(tsInterval);
                    }

                }, 250);
            } else {
                $(".fourth-swiper-controls").removeClass("d-none");
            }
            $(".fourth-swiper").removeClass("hidden-for-init");
        }, 400);
    });
    //</editor-fold>

    //<editor-fold desc="2. Swiper im Categories Widget neu initialiseren bei Tab Klick">
    $(".content__categories").on("click", "#service-tab", function () {

        if (isDesktopLarge) {
            if ($(".content__categories #service .content__categories--cat-swiper").length) {
                $(".content__categories #service .content__categories--cat-swiper").addClass("hidden-for-init");
                setTimeout(function () {
                    if (swiper6 !== undefined) {
                        swiper6.destroy();
                    }
                    var swiper6 = new Swiper(".content__categories #service .content__categories--cat-swiper", {
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        },
                        spaceBetween: 14,
                        loop: false,
                        slidesPerView: 6,
                        centeredSlides: false,
                        pagination: {
                            el: ".content__categories .swiper-pagination",
                            type: "fraction"
                        }
                    });
                    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                        var evt = document.createEvent("UIEvents");
                        evt.initUIEvent("resize", true, false, window, 0);
                        window.dispatchEvent(evt);
                    } else {
                        window.dispatchEvent(new Event("resize"));

                    }
                    if (isDesktopLarge) {
                        var tsInterval3 = setInterval(function () {

                            if ($(".content__categories--container .tab-pane.active .swiper-pagination").length) {
                                $(".content__categories--desktop-pagination").html("");
                                $(".content__categories--container .tab-pane.active .swiper-controls").appendTo(".content__categories--desktop-pagination");

                                var html = "";
                                var paginationMax = parseInt($(".content__categories--desktop-pagination .swiper-pagination-total").text());

                                for (var i = 0; i < paginationMax; i++) {
                                    if (i == 0) {
                                        html += "<div class=\"swiper-custom-pagination--bullet active\"></div>";
                                    } else {
                                        html += "<div class=\"swiper-custom-pagination--bullet\"></div>";
                                    }
                                }
                                $(".content__categories #service .content__categories--cat-swiper .swiper-custom-pagination").html(html);
                                swiper6.on("slideChange", function () {
                                    // bullet active
                                    var current = parseInt($(".content__categories--desktop-pagination .swiper-pagination-current").text());

                                    $(".content__categories #service .content__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet").removeClass("active");
                                    $(".content__categories #service .content__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet:nth-child(" + current + ")").addClass("active");
                                });
                                clearInterval(tsInterval3);
                            }

                        }, 250);
                    }

                    $(".content__categories #service .content__categories--cat-swiper").removeClass("hidden-for-init");

                }, 400);
            }
        }
    });
    //</editor-fold>

    //<editor-fold desc="2. Swiper im Homepage Categories Widget neu initialiseren bei Tab Klick">
    $(".homepage__categories").on("click", "#service-tab", function () {

        if (isDesktopLarge) {
            if ($(".homepage__categories #service .homepage__categories--cat-swiper").length) {
                $(".homepage__categories #service .homepage__categories--cat-swiper").addClass("hidden-for-init");
                setTimeout(function () {
                    if (swiper6 !== undefined) {
                        swiper6.destroy();
                    }
                    var swiper6 = new Swiper(".homepage__categories #service .homepage__categories--cat-swiper", {
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        },
                        spaceBetween: 14,
                        loop: false,
                        slidesPerView: 6,
                        centeredSlides: false,
                        pagination: {
                            el: ".homepage__categories .swiper-pagination",
                            type: "fraction"
                        }
                    });
                    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                        var evt = document.createEvent("UIEvents");
                        evt.initUIEvent("resize", true, false, window, 0);
                        window.dispatchEvent(evt);
                    } else {
                        window.dispatchEvent(new Event("resize"));

                    }
                    if (isDesktopLarge) {
                        var tsInterval3 = setInterval(function () {

                            if ($(".homepage__categories--container .tab-pane.active .swiper-pagination").length) {
                                $(".homepage__categories--desktop-pagination").html("");
                                $(".homepage__categories--container .tab-pane.active .swiper-controls").appendTo(".homepage__categories--desktop-pagination");
                                $(".homepage__categories--desktop-pagination .swiper-controls").removeClass("d-none");

                                var html = "";
                                var paginationMax = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-total").text());

                                for (var i = 0; i < paginationMax; i++) {
                                    if (i == 0) {
                                        html += "<div class=\"swiper-custom-pagination--bullet active\"></div>";
                                    } else {
                                        html += "<div class=\"swiper-custom-pagination--bullet\"></div>";
                                    }
                                }
                                $(".homepage__categories #service .homepage__categories--cat-swiper .swiper-custom-pagination").html(html);
                                swiper6.on("slideChange", function () {
                                    // bullet active
                                    var current = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-current").text());

                                    $(".homepage__categories #service .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet").removeClass("active");
                                    $(".homepage__categories #service .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet:nth-child(" + current + ")").addClass("active");
                                });
                                // $('.homepage__categories--desktop-pagination').removeClass("custom-styling");
                                clearInterval(tsInterval3);
                            }

                        }, 250);
                    }

                    $(".homepage__categories #service .homepage__categories--cat-swiper").removeClass("hidden-for-init");

                }, 400);
            }
        }
    });
    //</editor-fold>

    //<editor-fold desc="3. Swiper im Homepage Categories Widget neu initialiseren bei Tab Klick">
    $(".homepage__categories").on("click", "#inspiration-tab", function () {
        if (isDesktopLarge) {
            if ($(".homepage__categories #inspiration .homepage__categories--cat-swiper").length) {
                $(".homepage__categories #inspiration .homepage__categories--cat-swiper").addClass("hidden-for-init");
                setTimeout(function () {
                    if (swiper7 !== undefined) {
                        swiper7.destroy();
                    }

                    var swiper7 = new Swiper(".homepage__categories #inspiration .homepage__categories--cat-swiper", {
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        },
                        spaceBetween: 14,
                        loop: false,
                        slidesPerView: 6,
                        centeredSlides: false,
                        pagination: {
                            el: ".homepage__categories .swiper-pagination",
                            type: "fraction"
                        }
                    });
                    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                        var evt = document.createEvent("UIEvents");
                        evt.initUIEvent("resize", true, false, window, 0);
                        window.dispatchEvent(evt);
                    } else {
                        window.dispatchEvent(new Event("resize"));

                    }
                    if (isDesktopLarge) {
                        var tsInterval4 = setInterval(function () {

                            if ($(".homepage__categories--container .tab-pane.active .swiper-pagination").length) {
                                $(".homepage__categories--desktop-pagination").html("");
                                $(".homepage__categories--container .tab-pane.active .swiper-controls").appendTo(".homepage__categories--desktop-pagination");
                                $(".homepage__categories--desktop-pagination .swiper-controls").removeClass("d-none");

                                var html = "";
                                var paginationMax = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-total").text());

                                for (var i = 0; i < paginationMax; i++) {
                                    if (i == 0) {
                                        html += "<div class=\"swiper-custom-pagination--bullet active\"></div>";
                                    } else {
                                        html += "<div class=\"swiper-custom-pagination--bullet\"></div>";
                                    }
                                }
                                $(".homepage__categories #inspiration .homepage__categories--cat-swiper .swiper-custom-pagination").html(html);
                                swiper7.on("slideChange", function () {
                                    // bullet active
                                    var current = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-current").text());

                                    $(".homepage__categories #inspiration .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet").removeClass("active");
                                    $(".homepage__categories #inspiration .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet:nth-child(" + current + ")").addClass("active");
                                });
                                // $('.homepage__categories--desktop-pagination').removeClass("custom-styling");
                                clearInterval(tsInterval4);
                            }

                        }, 250);
                    }

                    $(".homepage__categories #inspiration .homepage__categories--cat-swiper").removeClass("hidden-for-init");

                }, 400);
            }
        }
    });
    //</editor-fold>

    //<editor-fold desc="4. Swiper im Homepage Categories Widget neu initialiseren bei Tab Klick">
    $(".homepage__categories").on("click", "#raeume-tab", function () {
        if (isDesktopLarge) {
            if ($(".homepage__categories #raeume .homepage__categories--cat-swiper").length) {
                $(".homepage__categories #raeume .homepage__categories--cat-swiper").addClass("hidden-for-init");
                setTimeout(function () {
                    if (swiper8 !== undefined) {
                        swiper8.destroy();
                    }
                    var swiper8 = new Swiper(".homepage__categories #raeume .homepage__categories--cat-swiper", {
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev"
                        },
                        spaceBetween: 14,
                        loop: false,
                        slidesPerView: 6,
                        centeredSlides: false,
                        pagination: {
                            el: ".homepage__categories .swiper-pagination",
                            type: "fraction"
                        }
                    });
                    if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                        var evt = document.createEvent("UIEvents");
                        evt.initUIEvent("resize", true, false, window, 0);
                        window.dispatchEvent(evt);
                    } else {
                        window.dispatchEvent(new Event("resize"));

                    }
                    if (isDesktopLarge) {
                        var tsInterval5 = setInterval(function () {

                            if ($(".homepage__categories--container .tab-pane.active .swiper-pagination").length) {
                                $(".homepage__categories--desktop-pagination").html("");
                                $(".homepage__categories--container .tab-pane.active .swiper-controls").appendTo(".homepage__categories--desktop-pagination");
                                $(".homepage__categories--desktop-pagination .swiper-controls").removeClass("d-none");

                                var html = "";
                                var paginationMax = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-total").text());

                                for (var i = 0; i < paginationMax; i++) {
                                    if (i == 0) {
                                        html += "<div class=\"swiper-custom-pagination--bullet active\"></div>";
                                    } else {
                                        html += "<div class=\"swiper-custom-pagination--bullet\"></div>";
                                    }
                                }
                                $(".homepage__categories #raeume .content__categories--cat-swiper .swiper-custom-pagination").html(html);
                                swiper8.on("slideChange", function () {
                                    // bullet active
                                    var current = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-current").text());

                                    $(".homepage__categories #raeume .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet").removeClass("active");
                                    $(".homepage__categories #raeume .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet:nth-child(" + current + ")").addClass("active");
                                });

                                // $('.homepage__categories--desktop-pagination').removeClass("custom-styling");

                                clearInterval(tsInterval5);
                            }

                        }, 250);
                    }

                    $(".homepage__categories #raeume .homepage__categories--cat-swiper").removeClass("hidden-for-init");

                }, 400);
            }
        }
    });
    //</editor-fold>

    //<editor-fold desc="Thumb Carousel Swiper Init">
    if ($(".category-item__thumbs-swiper").length)
    {
        var mySwiper = new Swiper(".category-item__thumbs-swiper", {
            spaceBetween: 5,
            slidesPerView: 6,
            allowTouchMove: false
        });
    }
    //</editor-fold>

    //<editor-fold desc="Artikelseite Varianten-Swiper Init">
    if ($(".single__variation-crossselling").length)
    {
        var crossswiperSingle = new Swiper(".single__variation-crossselling", {
            spaceBetween: 15,
            slidesPerView: 6
        });
    }
    //</editor-fold>

    if (isDesktopLarge) {

        //<editor-fold desc="1. Swiper im Homepage Categories Widget initialiseren bei Page-Load">
        if ($(".homepage__categories--cat-swiper-1").length) {
            var swiper4 = new Swiper(".homepage__categories--cat-swiper-1", {
                navigation: {
                    nextEl: ".homepage__categories--cat-swiper-1 .swiper-button-next",
                    prevEl: ".homepage__categories--cat-swiper-1 .swiper-button-prev"
                },
                spaceBetween: 14,
                loop: false,
                slidesPerView: 6,
                centeredSlides: false,
                pagination: {
                    el: ".homepage__categories--cat-swiper-1 .swiper-pagination",
                    type: "fraction"
                }
            });
            if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                var evt = document.createEvent("UIEvents");
                evt.initUIEvent("resize", true, false, window, 0);
                window.dispatchEvent(evt);
            } else {
                window.dispatchEvent(new Event("resize"));

            }
            var tsInterval1 = setInterval(function () {

                if ($(".homepage__categories--container .tab-pane.active .swiper-pagination").length) {
                    $(".homepage__categories--desktop-pagination").html("");
                    $(".homepage__categories--container .tab-pane.active .swiper-controls").appendTo(".homepage__categories--desktop-pagination");

                    var html = "";
                    var paginationMax = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-total").text());

                    for (var i = 0; i < paginationMax; i++) {
                        if (i == 0) {
                            html += "<div class=\"swiper-custom-pagination--bullet active\"></div>";
                        } else {
                            html += "<div class=\"swiper-custom-pagination--bullet\"></div>";
                        }
                    }
                    $(".homepage__categories--cat-swiper-1 .swiper-custom-pagination").html(html);
                    swiper4.on("slideChange", function () {
                        var current = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-current").text());

                        $(".homepage__categories--cat-swiper-1 .swiper-custom-pagination .swiper-custom-pagination--bullet").removeClass("active");
                        $(".homepage__categories--cat-swiper-1 .swiper-custom-pagination .swiper-custom-pagination--bullet:nth-child(" + current + ")").addClass("active");
                    });

                    $('.homepage__categories--desktop-pagination').addClass("custom-styling");

                    clearInterval(tsInterval1);
                }

            }, 400);
        }
        //</editor-fold>

        //<editor-fold desc="content categories swiper">
        if ($(".content__categories--cat-swiper").length) {
            var swiper5 = new Swiper("#alle-moebel .content__categories--cat-swiper", {
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                spaceBetween: 14,
                loop: false,
                slidesPerView: 6,
                centeredSlides: false,
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction"
                }
            });
            var tsInterval2 = setInterval(function () {

                if ($(".content__categories--container .tab-pane.active .swiper-pagination").length) {
                    $(".content__categories--desktop-pagination").html("");
                    $(".content__categories--container .tab-pane.active .swiper-controls").appendTo(".content__categories--desktop-pagination");
                    $(".homepage__categories--desktop-pagination .swiper-controls").removeClass("d-none");

                    var html = "";
                    var paginationMax = parseInt($(".content__categories--desktop-pagination .swiper-pagination-total").text());

                    for (var i = 0; i < paginationMax; i++) {
                        if (i == 0) {
                            html += "<div class=\"swiper-custom-pagination--bullet active\"></div>";
                        } else {
                            html += "<div class=\"swiper-custom-pagination--bullet\"></div>";
                        }
                    }
                    $(".content__categories--cat-swiper .swiper-custom-pagination").html(html);
                    swiper5.on("slideChange", function () {
                        // bullet active
                        var current = parseInt($(".content__categories--desktop-pagination .swiper-pagination-current").text());

                        $(".content__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet").removeClass("active");
                        $(".content__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet:nth-child(" + current + ")").addClass("active");
                    });
                    clearInterval(tsInterval2);
                }

            }, 250);
        }
        //</editor-fold>

        //<editor-fold desc="homepage categories swiper">
        $(".homepage__categories").on("click", "#alle-moebel-tab", function () {
            if (isDesktopLarge) {
                if ($(".homepage__categories #alle-moebel .homepage__categories--cat-swiper").length) {
                    $(".homepage__categories #alle-moebel  .homepage__categories--cat-swiper").addClass("hidden-for-init");
                    setTimeout(function () {
                        if (swiper8 !== undefined) {
                            swiper8.destroy();
                        }
                        var swiper8 = new Swiper(".homepage__categories #alle-moebel  .homepage__categories--cat-swiper", {
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev"
                            },
                            spaceBetween: 14,
                            loop: false,
                            slidesPerView: 6,
                            centeredSlides: false,
                            pagination: {
                                el: ".homepage__categories .swiper-pagination",
                                type: "fraction"
                            }
                        });
                        if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
                            var evt = document.createEvent("UIEvents");
                            evt.initUIEvent("resize", true, false, window, 0);
                            window.dispatchEvent(evt);
                        } else {
                            window.dispatchEvent(new Event("resize"));

                        }
                        if (isDesktopLarge) {
                            var tsInterval6 = setInterval(function () {

                                if ($(".homepage__categories--container .tab-pane.active .swiper-pagination").length) {
                                    $(".homepage__categories--desktop-pagination").html("");
                                    $(".homepage__categories--container .tab-pane.active .swiper-controls").appendTo(".homepage__categories--desktop-pagination");
                                    $(".homepage__categories--desktop-pagination .swiper-controls").removeClass("d-none");

                                    var html = "";
                                    var paginationMax = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-total").text());

                                    for (var i = 0; i < paginationMax; i++) {
                                        if (i == 0) {
                                            html += "<div class=\"swiper-custom-pagination--bullet active\"></div>";
                                        } else {
                                            html += "<div class=\"swiper-custom-pagination--bullet\"></div>";
                                        }
                                    }
                                    $(".homepage__categories #alle-moebel  .content__categories--cat-swiper .swiper-custom-pagination").html(html);
                                    swiper8.on("slideChange", function () {
                                        // bullet active
                                        var current = parseInt($(".homepage__categories--desktop-pagination .swiper-pagination-current").text());

                                        $(".homepage__categories #alle-moebel  .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet").removeClass("active");
                                        $(".homepage__categories #alle-moebel  .homepage__categories--cat-swiper .swiper-custom-pagination .swiper-custom-pagination--bullet:nth-child(" + current + ")").addClass("active");
                                    });
                                    clearInterval(tsInterval6);
                                }

                            }, 250);
                        }

                        $(".homepage__categories #alle-moebel  .homepage__categories--cat-swiper").removeClass("hidden-for-init");

                    }, 400);
                }
            }
        });
        //</editor-fold>
    }

    //<editor-fold desc="swiper duplicate click">
    $(".single-swiper").on("click", ".swiper-slide-duplicate a", function(event) {

        event.preventDefault();

        if (window.innerWidth > 991) {

            $.each($(".single-swiper a"), function(index, item) {
                delete $(item)[0].dataset.lightbox;
            });

            $(".single__swiper-full-screen-modal").addClass("is-open");

            // move in body wegen ipad pinch zoom
            $(".single__swiper-full-screen-modal").detach().appendTo("body");

            $(".single__thumb-swiper-container").addClass("is-open");

            // move in body wegen ipad pinch zoom
            $(".single__thumb-swiper-container").detach().appendTo(".single__swiper-full-screen-modal");

            $("body").addClass("full-screen-modal-open");

            this.transform = $("div[itemscope=\"itemscope\"]").css("transform");
            $("div[itemscope=\"itemscope\"]").css("transform", "unset").addClass("no-transition");

            // set inital img
            let $sel = $(".single__thumb-swiper .swiper-slide-thumb-active img").length ? $(".single__thumb-swiper .swiper-slide-thumb-active img") : $(".single__thumb-swiper .swiper-slide-active img");
            $(".single__swiper-full-screen-modal-img").show().attr("src", $sel[0].dataset.bigimg);
            $(".single__swiper-full-screen-modal-iframe").hide();
        }else {
            // zoom
            $.each($(".single-swiper a"), function(index, item)
            {
                $(item)[0].dataset.lightbox = "single-big-image-gallery";
            });
            $(event.target).parent("a").trigger("click");
            $("#lightbox").removeClass("is-zoomed");
            $(".lb-image")[0].style.webkitTransform = "translate3d(0px,0px,0px)";
            $(".lb-image")[0].style.transform = "translate3d(0px,0px,0px)";

            $("#lightbox.is-zoomed .lb-image, .lb-image").off("touchstart").unbind("touchstart");
            $("#lightbox.is-zoomed .lb-image, .lb-image").off("touchmove").unbind("touchmove");
            $("#lightbox.is-zoomed .lb-image, .lb-image").off("touchend").unbind("touchend");
        }
    });
    //</editor-fold>

    //<editor-fold desc="Content-Swiper Button Klick scroll to Element">
    $("a[href*=\"#\"]:not(.content-swiper__button)").click(function(ev)
    {

        if ($(this).closest(".homepage__categories").length < 1)
        {

            let anchor = $(this).attr("href");
            anchor = anchor.split("#")[1];

            if (anchor.length >= 1 && anchor.indexOf("tab") < 0)
            {
                if ($("#" + anchor).length > 0)
                {
                    if ($("#" + anchor).offset().top - 250 > $(window).scrollTop())
                    {
                        ev.preventDefault();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $("#" + anchor).offset().top - 250
                        }, 2000);
                    }
                }
            }
        }

    });
})
